var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipmentStatusGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 63,
    viewBox: "0 0 91 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1815_3224",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 63
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90.7909,
    height: 63,
    rx: 4,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1815_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-110.199 3.91176L-110.199 63H-242.703L-110.199 -224H-60.5095L80.2764 63H-60.5095L-60.5095 3.91176H-27.3834L-85.3541 -131.147L-143.325 3.91176H-110.199Z",
    fill: "#0CAE8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-115.197 3.91176L-115.197 63H-247.701L-115.197 -224H-65.5076L75.2784 63H-65.5076L-65.5076 3.91176H-32.3815L-90.3522 -131.147L-148.323 3.91176H-115.197Z",
    fill: "#06CEA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 27.5L21 24.9902C21 24.755 21.0628 24.5242 21.182 24.3215C21.3012 24.1188 21.4725 23.9516 21.678 23.8374L31.5917 18.3318H31.5904C31.9822 18.1142 32.423 18 32.8712 18C33.3194 18 33.7601 18.1142 34.1519 18.3318L44.0644 23.8374C44.2699 23.9516 44.4411 24.1188 44.5603 24.3215C44.6795 24.5242 44.7424 24.755 44.7424 24.9902V35.8523C44.7423 36.3227 44.6164 36.7846 44.3777 37.19C44.1391 37.5954 43.7964 37.9296 43.3851 38.158L34.1519 43.2889C33.7601 43.5065 33.3194 43.6207 32.8712 43.6207C32.423 43.6207 31.9822 43.5065 31.5904 43.2889L29 42",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 24.2151L32.8712 30.8102M32.8712 30.8102L44.7424 24.2151M32.8712 30.8102V44.0004",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9365 27.5121L38.8077 20.917",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.7143,
    cy: 38.7143,
    r: 7.71429,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4941 42.9965C17.7893 42.9718 18.0593 42.8206 18.2345 42.5818L22.4892 36.7815C22.8236 36.3257 22.7251 35.6851 22.2692 35.3507C21.8134 35.0163 21.1728 35.1148 20.8384 35.5706L17.2795 40.4223L15.7374 38.9223C15.3321 38.5281 14.6841 38.537 14.2899 38.9423C13.8957 39.3476 13.9047 39.9956 14.3099 40.3898L16.6953 42.7101C16.9076 42.9166 17.199 43.0211 17.4941 42.9965Z",
    fill: "#06CEA8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentStatusGreen);
export default __webpack_public_path__ + "static/media/shipment-status-green.5d31edfe87db720a914d70f46213dddd.svg";
export { ForwardRef as ReactComponent };